import { useAppRouter } from '@/common/route/useAppRouter';
import { timeUnits } from '@/common/utils/helpers';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useIAPList } from '@/modules/iap/model/list';
import { ROUTE_NAME_SUBSCRIPTION } from '@/modules/subscription/router';
import { subscriptionService } from '@/services/subscription';
import useVuelidate from '@vuelidate/core';
import { decimal, integer, maxValue, minValue, required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useSubscriptionAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { iapOptions, fetchIapOptions } = useIAPList();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: '',
        packageId: '',
        priceId: '',
        price: 0,
        maxReceivableTime: '',
        cycleChip: 0,
        timeUnit: 0,
        timeDuration: 0,
        totalLinked: null,
        startTime: new Date(),
        canDelete: false,
        canEdit: false
    });

    const validations = {
        name: { required },
        price: { required, decimal, minValue: minValue(0) },
        maxReceivableTime: { required, integer, minValue: minValue(1) },
        cycleChip: { required, integer, minValue: minValue(1) },
        timeDuration: { required, integer, minValue: minValue(1), maxValue: maxValue(59) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.id != null,
        request: () => subscriptionService.item.get(model.id),
        onSuccess: ({ data }) => {
            data.startTime = new Date(data.startTime);
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_SUBSCRIPTION.INDEX })
    });

    const actions = {
        create: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                subscriptionService.item.create(
                    model.id,
                    null,
                    model.name,
                    model.packageId,
                    model.priceId,
                    model.price,
                    model.maxReceivableTime,
                    model.cycleChip,
                    model.timeUnit,
                    model.timeDuration,
                    model.startTime?.getTime() ?? null
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_SUBSCRIPTION.INDEX })
        }),
        selectIAP: (iapId: any) => {
            iapOptions.value.forEach(item => {
                if (item.value == iapId) {
                    model.packageId = item.data.packageId;
                    model.price = item.data.price;
                }
            });
        }
    };

    onMounted(async () => {
        await fetchIapOptions();
        await fetch();
    });

    return { model, v$, timeUnits, iapOptions, fetch, actions };
}
